import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Dropdown from 'flarum/common/components/Dropdown';
import Link from 'flarum/common/components/Link';
/**
 * "Articles" header dropdown - the discussions of the "Articles" forum
 * chosen in the extension's settings, in their order there (see
 * ArticlesMenu.php), each linking straight to its own /article/:id page
 * (ArticlePage.js). Only ~10 discussions, small enough to ship in the
 * forum payload with no pagination - unlike the site's list pages
 * (/descriptions, /keys, /paintings) there's no /articles listing page
 * either, matching champis.net's own "Articles" nav item (a dropdown of
 * direct links, not a page of its own).
 */
export default class ArticlesMenu extends Component {
  view() {
    // Serialized into the forum payload (see ArticlesMenu.php) - no
    // request of its own, and no menu popping in once one comes back.
    const articles = app.forum.attribute('articlesMenu') || [];
    if (articles.length === 0) return null;
    return m(Dropdown, {
      buttonClassName: "Button Button--link",
      menuClassName: "ChampisForumsMenu-menu",
      label: app.translator.trans('champis-articles.forum.articles_menu.label'),
      accessibleToggleLabel: app.translator.trans('champis-articles.forum.articles_menu.toggle_accessible_label')
    }, articles.map(discussion => m(Link, {
      className: "ChampisForumsMenu-item",
      href: app.route('article', {
        id: discussion.id
      })
    }, discussion.title)));
  }
}
flarum.reg.add('champis-articles', 'forum/components/ArticlesMenu', ArticlesMenu);